import { render, staticRenderFns } from "./UserPasswordReset.vue?vue&type=template&id=6a60fba0&"
import script from "./UserPasswordReset.vue?vue&type=script&lang=js&"
export * from "./UserPasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports